'use strict';

import './scss/heimdall.scss';
import wc_heimdall from './js/modules/wc-heimdall.js';
import wp_heimdall from './js/modules/wp-heimdall.js';

$(document).ready(function($) {
  wp_heimdall();
  wc_heimdall();
});
